import React, { createContext, useContext, useState, useEffect } from 'react';
const ThemeContext = createContext();
export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => localStorage.getItem('ryzen-theme') || 'dark');
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('ryzen-theme', theme);
  }, [theme]);
  // Suppress all transitions for the frame of the switch so every element
  // (page, header bars, cards) flips colour at exactly the same time.
  const toggle = () => {
    const root = document.documentElement;
    root.classList.add('theme-switching');
    setTheme(t => t === 'dark' ? 'light' : 'dark');
    requestAnimationFrame(() => requestAnimationFrame(() => root.classList.remove('theme-switching')));
  };
  return <ThemeContext.Provider value={{ theme, toggle }}>{children}</ThemeContext.Provider>;
}
export const useTheme = () => useContext(ThemeContext);
